// @flow

import { Evented } from "../util/evented";

import type { Source } from "./source";
import type Map from "../ui/map";
import type CRS from "../geo/crs/crs";
import { applyClippingFeature } from "../util/clipping_geo";

// mapbox-gl-修改说明：新增source增强类，对source的增强方法，都可以写在这里
// 修改人：龚跃健 2024年6月17日
class SourceEnhance extends Evented implements Source {
    map: Map;
    _loaded: boolean;

    constructor() {
        super();
    }

    load() {}

    onAdd(map: Map) {
        this.map = map;
        this.load();
        // 初始化裁剪区
        const options = this._options || this.options
        if(options){
            this.setClippingArea(options.clippingArea)
        }
    }

    // mapbox-gl-修改说明：source上支持设置裁剪几何
    // 修改人：赵凯 2024年7月29日
    /**
     * @description: 设置裁剪区
     * @param {Object} geojsonObject(目前仅支持传入区或多区几何对象)
     * @return {*}
     */
    setClippingArea(data) {
        applyClippingFeature.call(this, data)
        // 触发刷新
        this.map._update();
    }

    /**
     * @description: 设置裁剪区
     * @param {Object} data geojson的object属性
     * @return {*}
     */
    getClippingArea() {
        return this._clippingFeature;
    }
}

export default SourceEnhance;
